module.exports = __webpack_public_path__ + "static/media/insights_bg.234b3815.jpg";